/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
/* eslint-disable eqeqeq */
import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  PieChart,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Cell,
  Pie,
  Tooltip as ChartTooltip,
} from 'recharts';
import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';

import {
  bind,
  equal,
  getHashCode,
  ifNil,
  isArray,
  isFunc,
  isNil,
  isNullOrWhitespace,
} from 'vdlib';
import CalendarReportFilter from './common/CalendarReportFilter';
import Portlet from '../layout/Portlet';
import { ReportPeriodTypes } from 'vdlib';
import LookupsHelper from 'lib/LookupsHelper';
import { REPORT_PALETTE } from 'lib/Constants';

const defaultPeriodType = ReportPeriodTypes.Monthly,
  maxInitialDisplayItems = 1000,
  noGroupingGroupMember = 'All';

// const CustomizedAxisTick = React.createClass({
//     render () {
//         const {x, y, stroke, payload} = this.props;

//         return (
//             <g transform={`translate(${x},${y})`}>
//             <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">{ payload.value }</text>
//             </g>
//         );
//     }
// });

const getMonthDays = date => {
  let month = date.getMonth();
  return month == 1 && date.getFullYear() % 4 == 0
    ? 29
    : month == 1
    ? 28
    : [0, 2, 4, 6, 7, 9, 11].indexOf(month) >= 0
    ? 31
    : 30;
};

class EntityGroupReport extends React.Component {
  constructor(props) {
    super(props);

    bind(this, [
      'populate',
      'changeDataMember',
      'changePeriodType',
      'changeGroupMember',
      'toggleLabel',
      'renderActions',
      'renderTitle',
      'fetchData',
      'formatData',
      'constructLabelCreators',
    ]);

    let dateTo = new Date();
    dateTo = new Date(
      `${dateTo.getFullYear()}-${dateTo.getMonth() + 1}-${getMonthDays(
        dateTo
      )}T00:00:00Z`
    );
    let dateFrom = new Date(dateTo);
    dateFrom.setMonth(dateFrom.getMonth() - 3);
    dateFrom.setDate(1);

    let dataMember = isNullOrWhitespace(this.props.defaultDataMember)
      ? null
      : this.props.dataMembers.find(
          dm => dm.ID == this.props.defaultDataMember
        );
    if (dataMember == null) dataMember = this.props.dataMembers[0];

    this.state = {
      dateFrom,
      dateTo,
      dateFromPrevious: dateFrom,
      dateToPrevious: dateTo,
      invalidDates: false,
      dataMember: dataMember.ID,
      groupMember: this.props.groupMembers[0].ID,
      periodType: defaultPeriodType,
      stacked: false,
      dataChangeRef: 0,
    };

    this.tooltipContentRenderer = props => {
      let listItems = false,
        noGroup = this.state.groupMember == noGroupingGroupMember,
        total =
          noGroup && props.payload && props.payload.length == 1
            ? props.payload[0].payload.ALL
            : 0,
        dataMember = this.props.dataMembers.find(
          d => d.ID == this.state.dataMember
        ),
        valueParser = isFunc(dataMember.valueParser)
          ? dataMember.valueParser
          : val => val;

      if (isArray(props.payload) && !noGroup) {
        listItems = [];
        for (let item of props.payload.filter(
          item => this.state.visibleLabels[item.dataKey] === true
        )) {
          let label = this.labels.find(l => l.key == item.dataKey),
            value = parseFloat(item.payload[item.name] || 0);
          total += value;
          listItems.push(
            <div
              className="chart-tooltip-item"
              key={`tooltip-item-${item.dataKey}`}
            >
              <div
                className="color-box"
                style={{ backgroundColor: this.colors[label.hashCode].stroke }}
              />
              <span>{label.title}</span>
              :&nbsp;&nbsp;
              <span className="bold">
                {valueParser(item.payload[item.name] || 0)}
              </span>
              <div style={{ clear: 'both' }} />
            </div>
          );
        }
      }

      return (
        <div className="chart-tooltip-wrap">
          {props.label}: <span className="bold">{valueParser(total)}</span>
          {this.state.groupMember == noGroupingGroupMember ? (
            false
          ) : (
            <hr className="clear mt-sm mb-sm" />
          )}
          {listItems}
        </div>
      );
    };

    this.tooltipPieContentRenderer = props => {
      if (!props.payload || props.payload.length == 0) return false;
      let dataMember = this.props.dataMembers.find(
          d => d.ID == this.state.dataMember
        ),
        valueParser = isFunc(dataMember.valueParser)
          ? dataMember.valueParser
          : val => val,
        item = props.payload[0],
        //TODO: Added during the split, check, how was this working???
        value = item.value,
        label = this.labels.find(l => l.key == item.name) || {};
      return (
        <div className="chart-tooltip-wrap">
          {label.title || ''}:{' '}
          <span className="bold">{valueParser(value)}</span>
        </div>
      );
    };
    this.constructLabelCreators();
    this.populate(props);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.lang !== nextProps.lang) {
      this.constructLabelCreators();
      this.populate(nextProps);
    }

    if (!equal(this.props.data, nextProps.data)) this.populate(nextProps);
  }

  constructLabelCreators() {
    this.months = [
      '',
      I.t('MONTH_JAN'),
      I.t('MONTH_FEB'),
      I.t('MONTH_MAR'),
      I.t('MONTH_APR'),
      I.t('MONTH_MAY'),
      I.t('MONTH_JUN'),
      I.t('MONTH_JUL'),
      I.t('MONTH_AUG'),
      I.t('MONTH_SEP'),
      I.t('MONTH_OCT'),
      I.t('MONTH_NOV'),
      I.t('MONTH_DEC'),
    ];

    this.periodLabelCreators = {
      [ReportPeriodTypes.All]: (...args) => args[0],
      [ReportPeriodTypes.Weekly]: (periodNo, periodKey, totalPeriods) =>
        periodKey.substr(6) +
        '-' +
        periodKey.substr(4, 2) +
        '-' +
        periodKey.substr(0, 4),
      [ReportPeriodTypes.Monthly]: (periodNo, periodKey, totalPeriods) =>
        `${this.months[parseInt(periodKey.substr(4))]} ${periodKey.substr(
          0,
          4
        )}`,
      [ReportPeriodTypes.Quarterly]: (periodNo, periodKey, totalPeriods) =>
        `Q${periodKey.substr(4)} ${periodKey.substr(0, 4)}`,
      [ReportPeriodTypes.Trimester]: (periodNo, periodKey, totalPeriods) =>
        periodKey,
      [ReportPeriodTypes.Biyearly]: (periodNo, periodKey, totalPeriods) =>
        `${
          periodKey.substr(4) + I.t('SEMESTER_COUNT') + periodKey.substr(0, 4)
        }`,
      [ReportPeriodTypes.Yearly]: (periodNo, periodKey, totalPeriods) =>
        periodKey,
    };
  }

  fetchData() {
    let dateTo = this.state.dateTo;
    dateTo.setDate(getMonthDays(dateTo));
    dateTo.setHours(23);
    dateTo.setSeconds(59);
    dateTo.setMinutes(59 + dateTo.getTimezoneOffset());

    if (!this.state.invalidDates) {
      this.props.fetchData({
        dateFrom: this.state.dateFrom,
        dateTo,
        periodType: this.state.periodType,
      });

      this.setState({
        dateFromPrevious: this.state.dateFrom,
        dateToPrevious: dateTo,
      });
    }
  }

  changeDataMember(eventKey, ev) {
    // datamember (auctions, amounts etc) changed, just reformat data
    this.setState({ dataMember: eventKey }, () => this.formatData());
  }

  changeGroupMember(eventKey, ev) {
    // groupmember (perExpert etc) changed, need to recalculate labels, colors & stuff
    this.setState({ groupMember: eventKey }, () => this.populate());
  }

  changePeriodType(eventKey, ev) {
    // period type (monthly etc) changed, fetch from server
    this.setState({ periodType: eventKey }, () => this.fetchData());
  }

  changeDate(key, value) {
    // date range changed, fetch from server
    let fromDate = key == 'dateFrom' ? value : this.state.dateFrom,
      toDate = key == 'dateTo' ? value : this.state.dateTo,
      invalidDates = fromDate > toDate;

    this.setState(
      {
        [key]: value,
        invalidDates,
      },
      () => {
        if (!invalidDates) this.fetchData();
      }
    );
  }

  toggleLabel(label) {
    // label visibility changed, just add data to the array
    if (!isArray(this.data) || this.data.length <= 0) return;

    let isVisible = this.state.visibleLabels[label.key] === true;
    for (let i = 0; i < this.data.length; i++) {
      if (isVisible) delete this.data[i][label.key];
      else this.data[i][label.key] = this.originalData[i][label.key];
    }

    this.setState({
      visibleLabels: Object.assign({}, this.state.visibleLabels, {
        [label.key]: !isVisible,
      }),
      dataChangeRef: this.state.dataChangeRef + 1,
    });
  }

  formatData(props) {
    if (isNil(props)) props = this.props;

    this.data = [];
    let rawData = props.data[this.state.groupMember];
    if (!isArray(rawData)) return;

    let periodLabelCreator = this.periodLabelCreators[this.state.periodType],
      totalPeriods = rawData.length,
      totals = null,
      multipleData = false;
    for (let period of rawData) {
      if (
        period.Data.length > 0 &&
        isArray(period.Data[0][this.state.dataMember])
      ) {
        multipleData = true;
        break;
      }
    }

    if (this.state.periodType != ReportPeriodTypes.All) {
      // format data for area chart
      totals = {};
      let periods = rawData.sort((a, b) => (a.OrderNo < b.OrderNo ? -1 : 1));
      for (let periodIdx = 0; periodIdx < periods.length; periodIdx++) {
        if (periodIdx >= maxInitialDisplayItems) break;
        let period = periods[periodIdx],
          datapoint = {
            name: periodLabelCreator(period.OrderNo, period.Key, totalPeriods),
          };

        period.Data.sort((a, b) =>
          a[this.state.dataMember] < b[this.state.dataMember] ? -1 : 1
        ).forEach(d => {
          let datum = d[this.state.dataMember];
          if (multipleData) {
            for (let datumIdx = 0; datumIdx < datum.length; datumIdx++) {
              let key = d.Key + '-' + datumIdx;
              if (!totals[key]) totals[key] = 0;
              totals[key] += parseFloat(datum[datumIdx]);
              datapoint[key] = datum[datumIdx];
            }
          } else {
            if (!totals[d.Key]) totals[d.Key] = 0;
            totals[d.Key] += parseFloat(datum);
            datapoint[d.Key] = datum;
          }
        });
        this.data.push(datapoint);
      }
    } else {
      //format data for pie chart
      this.data = rawData[0].Data.map(d => ({
        name: d.Key,
        value: parseFloat(d[this.state.dataMember]),
      }));
    }
    this.originalData = this.originalData = this.data.map(d =>
      Object.assign({}, d)
    );

    // this.data is not in state, trigger render
    this.setState({ dataChangeRef: this.state.dataChangeRef + 1 });

    return totals;
  }

  populate(props) {
    if (isNil(props)) props = this.props;

    this.data = [];
    this.labels = [];
    this.colors = {};

    if (isNil(props.data)) return;

    let totals = this.formatData(props);

    // format entities (experts, regions etc)
    let entities = ifNil(this.props.groupEntities[this.state.groupMember], {}),
      useLookup = isArray(entities.data);
    this.entitiesTitle = entities.title;

    // find all possible keys in data
    //const sorter = null;
    if (totals == null) {
      this.allKeys = this.data.map(d => d.name);
    } else {
      let allKeysObj = {};
      this.data.forEach(d =>
        Object.keys(d).forEach(key => (allKeysObj[key] = true))
      );
      this.allKeys = Object.keys(allKeysObj);
    }

    this.labels = (totals == null
      ? this.data
          .sort((d1, d2) => (d1.value > d2.value ? -1 : 1))
          .map(d => d.name)
      : this.allKeys
          .filter(key => key != 'name')
          .sort((key1, key2) => (totals[key1] > totals[key2] ? -1 : 1))
    )
      .map(l => {
        let title = useLookup
          ? LookupsHelper.getDescription(entities.data, l)
          : l;
        if (!title && entities.empty === false) return null;

        return {
          key: l,
          hashCode: getHashCode(l),
          title: title || entities.empty || I.t('EMPTY'),
        };
      })
      .filter(l => l != null);

    // show only the first 10 data items
    // TODO: sort biggest using data.All??
    if (totals != null) {
      let visibleLabelsObj = {};
      for (let labelIdx = 0; labelIdx < this.labels.length; labelIdx++) {
        let label = this.labels[labelIdx];
        this.colors[label.hashCode] = Object.assign(
          {},
          REPORT_PALETTE[labelIdx % REPORT_PALETTE.length]
        );
        visibleLabelsObj[label.key] = isNil(this.state.visibleLabels)
          ? true
          : typeof this.state.visibleLabels[label.key] === 'boolean'
          ? this.state.visibleLabels[label.key] === true
          : labelIdx < maxInitialDisplayItems;

        // remote exess items that don't qualify due to quantity
        if (labelIdx >= maxInitialDisplayItems)
          for (let dataIdx = 0; dataIdx < this.data.length; dataIdx++)
            delete this.data[dataIdx][label.key];
      }

      if (isNil(this.state.visibleLabels))
        // eslint-disable-next-line
        this.state.visibleLabels = visibleLabelsObj;
      else this.setState({ visibleLabels: visibleLabelsObj });
    } else {
      for (let labelIdx = 0; labelIdx < this.labels.length; labelIdx++)
        this.colors[this.labels[labelIdx].hashCode] = Object.assign(
          {},
          REPORT_PALETTE[labelIdx % REPORT_PALETTE.length]
        );
    }
  }

  renderActions() {
    return [
      <CalendarReportFilter
        style={{ width: '110px' }}
        onChange={e => this.changeDate('dateFrom', e._d)}
        defaultValue={this.state.dateFrom}
        title={I.t('DATE_FROM')}
        className={`pull-left ${
          this.state.invalidDates === true ? 'has-error' : ''
        }`}
      />,
      <div
        className="pull-left ml-sm mr-sm bold"
        style={{ lineHeight: '30px' }}
      >
        -
      </div>,
      <CalendarReportFilter
        style={{ width: '110px' }}
        onChange={e => this.changeDate('dateTo', e._d)}
        defaultValue={this.state.dateTo}
        title={I.t('DATE_UNTIL')}
        className={`pull-left mr-sm ${
          this.state.invalidDates === true ? 'has-error' : ''
        }`}
      />,
      <ButtonGroup className="pull-left btn-group-circle">
        {this.state.groupMember == noGroupingGroupMember ? (
          false
        ) : (
          <DropdownButton
            className={`btn btn-sm ${this.props.buttonsColor}`}
            bsStyle="info"
            title={this.entitiesTitle}
            id="entities-selector"
            pullRight
          >
            {this.labels.map((label, idx) => (
              <li>
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.toggleLabel(label);
                  }}
                >
                  <div
                    className={`color-box ${
                      this.state.visibleLabels[label.key] === true
                        ? ''
                        : 'empty'
                    } `}
                    style={{
                      backgroundColor: this.colors[label.hashCode].stroke,
                    }}
                  />
                  {label.title}
                </a>
              </li>
            ))}
          </DropdownButton>
        )}
        <DropdownButton
          className={`btn btn-sm ${this.props.buttonsColor}`}
          title={I.t('PERIOD')}
          bsStyle="info"
          id="period-type-selector"
          onSelect={this.changePeriodType}
          pullRight
        >
          <Dropdown.Item eventKey={ReportPeriodTypes.Weekly}>
            {I.t('PERIOD_WEEKLY')}
          </Dropdown.Item>
          <Dropdown.Item eventKey={ReportPeriodTypes.Monthly}>
            {I.t('PERIOD_MONTHLY')}
          </Dropdown.Item>
          <Dropdown.Item eventKey={ReportPeriodTypes.Quarterly}>
            {I.t('PERIOD_QUARTERLY')}
          </Dropdown.Item>
          <Dropdown.Item eventKey={ReportPeriodTypes.Quarterly}>
            {I.t('PERIOD_THIRD_YEARLY')}
          </Dropdown.Item>
          <Dropdown.Item eventKey={ReportPeriodTypes.Biyearly}>
            {I.t('PERIOD_HALF_YEARLY')}
          </Dropdown.Item>
          <Dropdown.Item eventKey={ReportPeriodTypes.Yearly}>
            {I.t('PERIOD_YEARLY')}
          </Dropdown.Item>
          <Dropdown.Item divider />
          <Dropdown.Item eventKey={ReportPeriodTypes.All}>
            {I.t('ALL')}
          </Dropdown.Item>
        </DropdownButton>
        <DropdownButton
          bsStyle="info"
          className="btn dark btn-sm"
          title={<i className="fa fa-gear" />}
          id="options-selector"
          pullRight
        >
          <li>
            <a
              href="#"
              onClick={() => this.setState({ stacked: !this.state.stacked })}
            >
              Stacked
              <i
                className={`fa fa-${this.state.stacked ? 'check' : 'times'}`}
              />
            </a>
          </li>
        </DropdownButton>
      </ButtonGroup>,
    ];
  }

  renderTitle() {
    return (
      <div className="btn-group btn-group-circle" style={{ marginTop: '-5px' }}>
        <DropdownButton
          className={`pull-left btn btn-sm ${this.props.buttonsColor}`}
          bsStyle="info"
          title={
            (
              this.props.dataMembers.find(
                dm => dm.ID == this.state.dataMember
              ) || {}
            ).Description || ''
          }
          id="property-selector"
          onSelect={this.changeDataMember}
        >
          {this.props.dataMembers.map(dm => (
            <Dropdown.Item key={dm.ID} eventKey={dm.ID}>
              {dm.Description}
            </Dropdown.Item>
          ))}
        </DropdownButton>
        <DropdownButton
          className={`pull-left btn btn-sm ${this.props.buttonsColor}`}
          bsStyle="info"
          title={
            (
              this.props.groupMembers.find(
                gm => gm.ID == this.state.groupMember
              ) || {}
            ).Description || ''
          }
          id="group-selector"
          onSelect={this.changeGroupMember}
        >
          {this.props.groupMembers.map(gm => (
            <Dropdown.Item key={gm.ID} eventKey={gm.ID}>
              {gm.Description}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </div>
    );
  }

  render() {
    return (
      <div id="reports-wrap">
        <Portlet
          title={this.renderTitle()}
          actions={this.renderActions()}
          loading={this.props.fetching}
        >
          <ResponsiveContainer width="100%" height={300}>
            {this.state.periodType === ReportPeriodTypes.All ? (
              <PieChart>
                <Pie data={this.data} label fill="#8884d8">
                  {this.data.map((d, index) => {
                    let label = this.labels.find(l => l.key == d.name) || {};
                    return (
                      <Cell fill={(this.colors[label.hashCode] || {}).fill} />
                    );
                  })}
                </Pie>
                <ChartTooltip
                  animationEasing="ease-out"
                  animationDuration={350}
                  content={this.tooltipPieContentRenderer}
                />
              </PieChart>
            ) : (
              <AreaChart
                data={this.data}
                margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                stackOffset="none"
              >
                <defs>
                  {this.labels.map(label => (
                    <linearGradient
                      key={`${label.hashCode}-gradient`}
                      id={`${label.hashCode}-color`}
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop
                        offset="5%"
                        stopColor={this.colors[label.hashCode].fill}
                        stopOpacity={1}
                      />
                      <stop
                        offset="95%"
                        stopColor={this.colors[label.hashCode].fill}
                        stopOpacity={0.1}
                      />
                    </linearGradient>
                  ))}
                </defs>
                <XAxis dataKey="name" interval={0} angle={-45} />
                <YAxis />
                <CartesianGrid strokeDasharray="3 3" />
                <ChartTooltip
                  animationEasing="ease-out"
                  animationDuration={350}
                  content={this.tooltipContentRenderer}
                />
                {this.labels.map((label, idx) => (
                  <Area
                    key={label.key}
                    type="monotone"
                    dataKey={label.key}
                    stackId={this.state.stacked === true ? 1 : idx}
                    stroke={this.colors[label.hashCode].stroke}
                    fillOpacity={1}
                    fill={`url(#${label.hashCode}-color)`}
                  />
                ))}
              </AreaChart>
            )}
          </ResponsiveContainer>
        </Portlet>
      </div>
    );
  }
}

EntityGroupReport.propTypes = {
  buttonsColor: PropTypes.string,
  data: PropTypes.object,
  dataMembers: PropTypes.array.isRequired,
  defaultDataMember: PropTypes.string,
  entities: PropTypes.array,
  fetching: PropTypes.bool,
  groupMembers: PropTypes.array.isRequired,
  groupEntities: PropTypes.object,
  title: PropTypes.string,
};

export default EntityGroupReport;
